import { render, staticRenderFns } from "./ApiQueries.vue?vue&type=template&id=2f1b65fe&"
import script from "./ApiQueries.vue?vue&type=script&lang=ts&"
export * from "./ApiQueries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports